import {CardId, TransactionId} from '@raison/types';
import {InfoPage, RsnButton, RsnTextButton} from '@raison/ui-kit';
import BigNumber from 'bignumber.js';
import React from 'react';
import {Link} from 'react-router';
import {Currency, useCurrencyFormat} from '~/entities/currencies';

export type SendConfirmationFinishState = {
    amount: BigNumber;
    orderId: TransactionId;
};

const directions = {
    in: '+',
    out: '-',
};

export function CardTopupOrderInfoPage({
    currency,
    amount,
    goToDetails,
    direction,
    cardId,
    isCardVerified,
}: {
    currency: Currency;
    amount: string | BigNumber;
    goToDetails: () => void;
    direction: keyof typeof directions;
    cardId: CardId;
    isCardVerified: boolean;
}) {
    const {format: formatAsSubject} = useCurrencyFormat(currency);
    const amountText = formatAsSubject(amount);
    const t = {
        Heading: directions[direction] + amountText,
        Details: isCardVerified
            ? 'Top-up request submitted.\nProcessing may take some time.'
            : 'Top-up request submitted. It will remain pending until you verify your card.',
        Later: 'Later',
        ViewDetails: 'View operation details',
        VerifyCard: 'Verify card',
        GoHome: 'Back to home',
    };

    return (
        <InfoPage.Layout symbol='success'>
            {{
                center: (
                    <InfoPage.Center heading={t.Heading} details={t.Details}>
                        <RsnTextButton.Block decoration='arrow-right' size={'l'} onClick={goToDetails}>
                            {t.ViewDetails}
                        </RsnTextButton.Block>
                    </InfoPage.Center>
                ),
                footer: (
                    <InfoPage.Footer>
                        {!isCardVerified && (
                            <RsnButton.Alike intent={'primary'} as={Link} to={`/cards/${cardId}/verify`}>
                                {t.VerifyCard}
                            </RsnButton.Alike>
                        )}
                        <RsnButton.Alike intent={isCardVerified ? 'primary' : 'secondary'} as={Link} to={'/'}>
                            {isCardVerified ? t.GoHome : t.Later}
                        </RsnButton.Alike>
                    </InfoPage.Footer>
                ),
            }}
        </InfoPage.Layout>
    );
}
